import { IReportType } from '../util/DataModelInterface';
import * as rest from './RestUtil';
import * as storage from '../util/StorageUtil';
import { getFunctionBaseUrl } from './RestUrls';

export const getReportTypes = async (force: boolean = false) => {
  let reportTypes = storage.getReportTypes();
  if (!reportTypes || reportTypes.length === 0 || force) {
    const url = `${getFunctionBaseUrl()}/api/getReportTypes`;
    const response: IReportType[] = await rest.get(url);
    reportTypes = response;
    storage.setReportTypes(reportTypes);
  }
  return reportTypes;
}